<template>
<div>
    <div class="container">
        <logo/>
        <centered-card>
            <div v-if="view=='form'">
                <h2>Forgot your Password?</h2>
                <p>Just enter you E-Mail below and reset your password.</p>
                <div class="form-group">
                    <label>E-Mail</label>
                    <input type="text" class="form-control" v-model="email"/>
                </div>
                <indicator-button class="btn btn-primary" :click="resetPassword" :is-loading="isLoading">Reset Password</indicator-button>

            </div>

            <div v-if="view=='requested'">
                <h2>You've got Mail!</h2>
                <p>Please check you mails, and maybe take a look into your spam-folder. Sometimes good mails go there...</p>
            </div>

            <div v-if="view=='key'">
                <h2>Resetting your password</h2>
                <p>Please wait ...</p>
            </div>

            <div v-if="view=='keysent'">
                <h2>Your password was reset!</h2>
                <p>Please check you mails, there you will find your new password.</p>
            </div>

            <div v-if="view=='error'">
                <p class="text-danger">{{error}}</p>
                <p>Please contact our Support at: <a href="mailto:feedback@pimblr.com?subject=Password Problems">feedback@pimblr.com</a></p>

            </div>
            <hr>
            <p>
                <router-link :to="{name:'Login'}">Login</router-link> | <router-link :to="{name:'Registration'}">Register</router-link>
            </p>
        </centered-card>
    </div>
</div>
</template>

<script>


    import Logo from '../layout/CenterLogo.vue';
    import CenteredCard from "../layout/CenteredCard";
    import IndicatorButton from '../ui/buttons/IndicatorButton'

    export default {
        name: 'ForgotPwPage',
        metaInfo: {
            title: 'Forgot your Password?',
            meta: [
                  {vmid:'description', name: 'description', content: 'Retrieve a new Pimblr Password'},
                  {vmid:'title', name: 'title', content: 'Forgot your Password?'}
            ]
        },
        data(){
            return {
                view: 'form',
                email: '',
                error: '',
                isLoading: false
            }
        },
        mounted() {
            if(this.$route.params.key){
                this.view = 'key';
                this.isLoading = true;
                this.$api.retrievePw(this.$route.params.key)
                    .then(()=>{
                        this.view = 'keysent'
                        this.isLoading = false;
                    })
                    .catch(()=>{
                        this.view = 'error';
                        this.isLoading = false;
                        this.error = 'We could not reset your password.';
                    })
            }
        },
        methods: {
            resetPassword(){
                this.isLoading = true;
                this.$api.forgotPw(this.email)
                    .then(()=>{
                        this.view = 'requested';
                        this.isLoading = false;
                    })
                    .catch(()=>{
                        this.isLoading = false;
                    })
            }
        },
        components:{
            CenteredCard,
            Logo,
            IndicatorButton
        }

    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/components/user/ForgotPwPage.vue